jQuery( document ).ready(function() {

    /**
     * Klarna OSM checkout page purchase amount update function.
     * Value of `data-purchase-amount` is updated every time user modifies cart on the checkout page.
     */
    if (document.getElementById('klarna-checkout-placement')) {
        jQuery(document).on('wc_fragments_refreshed ', function(e){
            setTimeout(function() {
                let total = jQuery('div.order-total span.gm_price__value').html();

                jQuery('#klarna-checkout-placement').attr('data-purchase-amount', Math.round(total * 100));
                window.Klarna.OnsiteMessaging.refresh();
            }, 1000)

        });
    }
});